<!--Table-->
<div class="table-main-body" [style.MaxWidth]="MaxWidth" style="margin-left: auto; margin-right: auto">
	<p-table
		#mydt
		[value]="lstColumnTable"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Column Names-->
			<tr style="height: 4rem">
				<th *ngFor="let col of TabCols; let i = index">
					<select [disabled]="ImportStatusID != 3" class="form-control" [(ngModel)]="OptArray[i]">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstColumnOptions" [ngValue]="o.ID">
							{{ o.Desc }}
						</option>
					</select>
				</th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-RowItem>
			<tr [pSelectableRow]="RowItem">
				<td *ngFor="let col of RowItem; let i = index" style="font-weight: bold">
					{{ RowItem[i] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
